import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    project: String
  }

  connect() {
    // Load saved preferences from localStorage
    this.loadPreferences()

    // Update highlights based on current URL
    this.updateHighlights()

    // Listen for Turbo navigation to update highlights
    document.addEventListener("turbo:load", this.updateHighlights.bind(this))
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.updateHighlights.bind(this))
  }

  // Load preferences from localStorage
  loadPreferences() {
    const key = this.getStorageKey()
    const preferences = localStorage.getItem(key)

    if (preferences) {
      try {
        const { view, sort } = JSON.parse(preferences)
        // Preferences are applied via URL params when user clicks view/sort links
        // This is mainly for future enhancements like remembering scroll position
      } catch (error) {
        console.error("Failed to load preferences:", error)
      }
    }
  }

  // Save preferences to localStorage
  savePreferences(view, sort) {
    const key = this.getStorageKey()
    const preferences = { view, sort }
    localStorage.setItem(key, JSON.stringify(preferences))
  }

  // Get localStorage key for this project
  getStorageKey() {
    return `asset-preferences-${this.projectValue}`
  }

  // Handle view change
  viewChanged(event) {
    const url = new URL(event.currentTarget.href)
    const view = url.searchParams.get("view")
    const sort = url.searchParams.get("sort") || "ordered"

    this.savePreferences(view, sort)
  }

  // Handle sort change
  sortChanged(event) {
    const url = new URL(event.currentTarget.href)
    const view = url.searchParams.get("view") || "grid"
    const sort = url.searchParams.get("sort")

    this.savePreferences(view, sort)
  }

  // Update highlights based on current URL params
  updateHighlights() {
    const urlParams = new URLSearchParams(window.location.search)
    const currentView = urlParams.get("view") || "grid"
    const currentSort = urlParams.get("sort") || "ordered"

    // Update sort option highlights
    this.element.querySelectorAll("[data-sort-option]").forEach(link => {
      const url = new URL(link.href)
      const sortValue = url.searchParams.get("sort")

      if (sortValue === currentSort) {
        link.classList.add("bg-gray-900", "text-white")
        link.classList.remove("text-gray-700", "hover:bg-gray-100")
      } else {
        link.classList.remove("bg-gray-900", "text-white")
        link.classList.add("text-gray-700", "hover:bg-gray-100")
      }
    })

    // Update view mode highlights
    this.element.querySelectorAll("[data-view-option]").forEach(link => {
      const url = new URL(link.href)
      const viewValue = url.searchParams.get("view")

      if (viewValue === currentView) {
        link.classList.add("bg-gray-900", "text-white")
        link.classList.remove("text-gray-600", "hover:bg-gray-100")
      } else {
        link.classList.remove("bg-gray-900", "text-white")
        link.classList.add("text-gray-600", "hover:bg-gray-100")
      }
    })
  }
}
